/* eslint-disable max-len */

export default {
  404: {
    data: {
      title: '404 | k6',
      description: 'k6 Not Found Page',
    },
  },
  about: {
    data: {
      title: 'About us | Grafana k6',
      description:
        'This is k6. The story of how we got started on the journey to providing the best load testing platform on the planet.',
    },
  },
  cloud: {
    data: {
      title: 'Cloud load testing SaaS for engineering teams | k6 Cloud',
      description:
        'The k6 Cloud is a fully-managed load testing service that complements k6 to accelerate your performance testing.',
    },
  },
  'cloud-features': {
    data: {
      title: 'k6 Cloud Features',
      description:
        'The most relevant k6 Cloud features. k6 Cloud is a cloud-based load testing service that complements k6 to bring teams together for performance testing.',
    },
  },
  'cloud-support': {
    data: {
      title: 'k6 Cloud Support',
      description:
        'Get assistance with every step of your project from onboarding and training to continuous testing and project success',
    },
  },
  community: {
    data: {
      title: 'Community | k6',
      description: 'Welcome to community page of k6 project!',
    },
  },
  contact: {
    data: {
      title: 'Contact us | k6',
      description: 'Need to get in touch with the team? We’d love to hear from you.',
    },
  },
  'cookie-policy': {
    data: {
      title: 'Cookie Policy | k6',
      description:
        'We want to be transparent with the way we use cookies and therefore we provide you with a detailed description below of our use of cookies, as well as how you can control which cookies we use.',
    },
  },
  'data-processing-agreement': {
    data: {
      title: 'Data Processing Agreement | k6',
      description: 'LoadImpact GDPR Data Processing Agreement',
    },
  },
  'data-processing-agreement-20200116': {
    data: {
      title: 'Data Processing Agreement - January 16, 2020 | k6',
      description: 'LoadImpact GDPR Data Processing Agreement. Last updated January 16, 2020.',
    },
  },
  'data-sub-processors-20200128': {
    data: {
      title: 'Data Subprocessors - January 28, 2020 | k6',
      description: 'Subprocessors of Personal Data and Customer Data',
    },
  },
  'data-sub-processors': {
    data: {
      title: 'Data Subprocessors | k6',
      description: 'Subprocessors of Personal Data and Customer Data',
    },
  },
  index: {
    data: {
      title: 'Load testing for engineering teams | Grafana k6',
      description:
        'k6 is an open-source tool and cloud service that makes load testing easy for developers and QA engineers.',
    },
  },
  jobs: {
    data: {
      title: 'Jobs | Grafana k6',
      description:
        'We are on a mission to democratize load testing by providing a developer-centric experience fit for the modern engineering teams of the world.',
    },
  },
  'k6-cloud-for-education': {
    data: {
      title: 'k6 Cloud for Education',
      description:
        'The Education Program provides a free k6 Cloud subscription for community champions teaching performance testing with k6 at universities, meetups, and other events.',
    },
  },
  'k6-cloud-for-education-apply': {
    data: {
      title: 'Apply to the k6 Cloud for Education Program',
      description:
        'The Education Program provides a free k6 Cloud subscription for community champions teaching performance testing with k6 at universities, meetups, and other events. Apply here.',
    },
  },
  'open-source': {
    data: {
      title: 'Open-source load testing tool for developers | k6 OSS',
      description: 'A modern load testing tool built for developer happiness. Free to run on your infrastructure.',
    },
  },
  'oss-program': {
    data: {
      title: 'Open Source Support Program | k6 OSS',
      description: 'We support qualifying open source projects with free subscriptions for our products.',
    },
  },
  'oss-program-apply': {
    data: {
      title: 'Apply to the k6 Open Source Support Program',
      description: 'We support qualifying open source projects with free subscriptions for our products. Apply here.',
    },
  },
  'proof-of-concept': {
    data: {
      title: 'Load and Performance Testing Proof of Concept | k6',
      description:
        'This worksheet is intended to help guide you to create a proof of concept and stay focused on the core task. A proof of concept should be fairly narrow in focus to start and able to easily expand should you have the time.',
    },
  },
  'our-beliefs': {
    data: {
      title: 'Our beliefs - Load testing manifesto',
      description:
        'We have a strong conviction of what developer-centric load testing in the era of DevOps should look like.',
    },
  },
  'oss-vs-cloud': {
    data: {
      title: 'Comparing k6 Open Source and k6 Cloud',
      description:
        'We compare k6 Cloud and k6 Open Source to understand the value add the k6 Cloud over an open-source stack.',
    },
  },
  pricing: {
    data: {
      title: 'Plan & Pricing | k6 Cloud',
      description:
        'Pricing information and included features for k6 Cloud, as well as our addons prices and frequently asked questions.',
    },
  },
  'privacy-policy-20200116': {
    data: {
      title: 'Privacy Policy - January 16, 2020 | k6',
      description:
        'Information on what personal data LoadImpact collects and how we process it. Last updated January 16, 2020.',
    },
  },
  'privacy-policy': {
    data: {
      title: 'Privacy Policy | k6',
      description: 'Information on what personal data LoadImpact collects and how we process it.',
    },
  },
  'resources-library': {
    data: {
      title: 'Resource Library | k6',
      description: 'Learn more about how to use k6 to ship fast and reliable applications all the time.',
    },
  },
  'security-policy': {
    data: {
      title: 'Grafana Labs k6 Security Policy | Grafana Labs',
      description:
        'Last updated February 10, 2022. Introduction. Grafana Labs will maintain appropriate administrative, physical, and technical safeguards for protection of …',
    },
  },
  'security-policy-20200116': {
    data: {
      title: 'Security Policy - January 16, 2020 | k6',
      description:
        'As further described in this LoadImpact Information Security Policy, LoadImpact uses commercially reasonable organizational and technical measures designed to prevent unauthorized access, use, alteration or disclosure of Personal Data and Customer Data stored on systems under LoadImpact’s control.',
    },
  },
  'services-agreement-20201127': {
    data: {
      title: 'Services Agreement - November 27, 2020 | k6',
      description: 'General terms and conditions for using the LoadImpact service. Last updated November 27, 2020.',
    },
  },
  'services-agreement-20200121': {
    data: {
      title: 'Services Agreement - January 21, 2020 | k6',
      description: 'General terms and conditions for using the LoadImpact service. Last updated January 21, 2020.',
    },
  },
  'services-agreement': {
    data: {
      title: 'Grafana Labs k6 Services Agreement | Grafana Labs',
      description:
        'Last updated February 10, 2022. GENERAL  1.1 This Agreement shall apply to all offers and agreements under which Grafana Labs provides Services to the …',
    },
  },
  'solution-sheet': {
    data: {
      title: 'Why Your Organization Should Perform Load Testing',
      description:
        'Load testing benefits your organization in many ways. This article explains why load testing is important for your engineering operation and your business.',
    },
  },
  testimonials: {
    data: {
      title: 'k6 Testimonials - What Our Users Say About Us',
      description: 'Thousands of teams and developers use k6 every day. Read their use cases and stories.',
    },
  },
  slack: {
    data: {
      title: 'Slack | k6',
      description: 'k6 Community in Slack.',
    },
  },
  stewardship: {
    data: {
      title: 'Stewardship | k6',
      description:
        'Load Impact is a for profit organization, and recognizes that there is a need to balance this requirement with the needs of the k6 open source project.',
    },
  },
  'unit-testing-for-performance': {
    data: {
      title: 'Like unit testing, for performance | k6',
      description:
        'Pass/Fail behavior in your performance tests for easy automation and integration into CI pipelines. Receive alerts on performance regressions.',
    },
  },
  'azure-vs-k6': {
    data: {
      title: 'Azure vs k6 - Load testing for engineering teams',
      description: 'Join thousands of developers and enjoy a greater DX and flexibility for your Azure DevOps testing.',
    },
  },
  'loadrunner-alternative': {
    data: {
      title: 'k6 - LoadRunner Alternative',
      description: 'Join thousands of engineering teams shifting left with k6 to accelerate your performance testing.',
    },
  },
  'stress-testing': {
    data: {
      title: 'Stress Testing | k6',
      description: 'Scale your tests up to 100K concurrent virtual users and beyond.',
    },
  },
  'website-stress-testing': {
    data: {
      title: 'Website Stress Testing | k6',
      description: 'Scale website stress tests up to 100K concurrent virtual users and beyond.',
    },
  },
  'loadninja-alternative': {
    data: {
      title: 'k6 - LoadNinja Alternative',
      description:
        'Join thousands of engineering teams and enjoy a greater developer experience, flexibility and scalability with k6.',
    },
  },
  'blazemeter-alternative': {
    data: {
      title: 'k6 - Blazemeter Alternative',
      description:
        'Switch to k6 and join thousands of engineering teams that enjoy a greater developer experience and flexibility with k6.',
    },
  },
  'professional-services': {
    data: {
      title: 'Professional Services for performance testing | k6',
      description:
        'With 20+ years of experience, our professional services team is available to help your organization with your performance testing and success.',
    },
  },
  'case-study-fubotv': {
    data: {
      title: 'fuboTV Tackles Performance Regressions Before Production with k6 Cloud ',
      description:
        'Thanks to k6 Cloud, developers have the confidence to make complicated performance improvements that would be impossible to verify without proper testing.',
    },
  },
  'case-study-olo': {
    data: {
      title: 'Olo Delivers Faster Testing and Improved Collaboration with k6 Cloud',
      description:
        'With k6, performance testing has become a common practice, allowing Olo’s teams to continuously improve the platform and provide on-demand restaurant customers a seamless and enjoyable experience.',
    },
  },
  'case-study-carvana': {
    data: {
      title: 'Carvana Speeds Up Test Creation by 100% with k6',
      description:
        'Using k6 Cloud Enterprise, Carvana’s QE team has seen overwhelmingly positive results in developer participation, leadership confidence, and testing turnaround.',
    },
  },
  'white-paper-collaboration': {
    data: {
      title: 'Modern Load Testing for Engineering Teams | k6',
      description:
        "This white paper looks at trends, challenges, and best practices in the software industry that have impacted today's load testing processes.",
    },
  },
  'white-paper': {
    data: {
      title: 'What to Consider When Building or Buying a Load Testing Solution | k6',
      description:
        'In this white paper, we look at the features to contemplate when implementing your load testing solution and the challenges engineering teams need to consider outgrowing the initial solution.',
    },
  },
  'champions-program': {
    data: {
      title: 'Help k6 strengthen the community | Champions Program',
      description:
        'The k6 Champions Program aims to recognize experts within our community to amplify their contributions and partner with the k6 team.',
    },
  },
  'hybrid-performance-testing': {
    data: {
      title: 'Hybrid Performance Testing for Websites | k6',
      description:
        'End-to-end browser testing and load testing in the same k6 script. Use the same tool for frontend and backend performance testing',
    },
  },
  'fault-injection-testing': {
    data: {
      title: 'Fault Injection Testing with k6',
      description:
        'Build fault tolerant Kubernetes applications. Proactively test for (un)expected errors to improve reliability and resiliency.',
    },
  },
};
